
export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  aa:process.env.VUE_APP_AA,
  baseUrl: process.env.VUE_APP_BASE_URL,
  userBaseUrl: "/member",
  userFundUrl: "/fund",
  userReportUrl: "/report",
  userReviewUrl: "/memberreview",
  userEventUrl: "/event",
  userFavurl: "/game",
  campaignUrl:"/campaign",
  cmsUrl: "/cms",
  couponUrl: "/couponcode",
  paymentGatewayUrl: "/payg",
  bankList: [],
  account_name: "EPICWIN Philippines",
  epicGame: process.env.VUE_APP_EPIC_URL,
  epic2: process.env.VUE_APP_EPIC2_URL,
  awcGame: process.env.VUE_APP_AWC_URL,
  sabongGame: process.env.VUE_APP_SABONG_URL,
  ironClaw:process.env.VUE_APP_IRONCLAW_URL,
  live22Game: process.env.VUE_APP_LIVE22_URL,
  evoGame: process.env.VUE_APP_EVO_URL,
  tpGame: process.env.VUE_APP_TP_URL,
  hacksawGame: process.env.VUE_APP_HACKSAW_URL,
  t1Game: process.env.VUE_APP_T1_URL,
  fcGame: process.env.VUE_APP_FC_URL,
  jiliGame: process.env.VUE_APP_JILI_URL,
  cq9Game: process.env.VUE_APP_CQ9_URL,
  habaneroGame: process.env.VUE_APP_HABANERO_URL,
  ppsGame:process.env.VUE_APP_PRAGMATIC_URL,
  ppCasino: process.env.VUE_APP_PRAGCASINO_URL,
  launchOne: process.env.VUE_APP_LAUNCHONE_URL,
  ygrGame: process.env.VUE_APP_LAUNCHYGR_URL,
  wowApi: process.env.VUE_APP_LAUNCHWOW_URL,
  tblGame: process.env.VUE_APP_LAUNCHTBL_URL,
  launchOpen: process.env.VUE_APP_LAUNCHOPEN_URL,
  wBet:process.env.VUE_APP_WBET_URL,
  epicResultUrl: process.env.VUE_APP_EPIC_RESULT,
  tblResultUrl: process.env.VUE_APP_TBL_RESULT,
  useConfigUrl: process.env.VUE_APP_STATIC_URL,
  imageUrl: process.env.VUE_APP_IMAGE_URL,
  imageUpload: process.env.VUE_APP_IMAGE_UPLOAD,
  min: 67,
  max: 94,
  precision: 2,

  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    
    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }
    
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },

  getBaseUrl() {
    if (this.useConfigUrl == "true") {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      if(this.useConfigUrl == "true"){
        return this.baseUrl;
      }else{
        return "https://api." + domain;
      }     
    } else { 
      return this.baseUrl;
    }
  },

  membersignup() {
    return this.getBaseUrl() + this.userBaseUrl + "/membersignup";
  },
  memberLogin() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlogin";
  },
  mbTacLogin(){
    return this.getBaseUrl() + this.userBaseUrl + "/mbtaclogin";
  },
  mbNewLogin(){
    return this.getBaseUrl() + this.userBaseUrl + "/mbnewlogin";
  },
  getBalance() {
    return this.getBaseUrl() + this.userFundUrl + "/getbalance";
  },
  updatePassword() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberupdatepassword";
  },
  forgotPassword() {
    return this.getBaseUrl() + this.userBaseUrl + "/forgotpassword";
  },
  profileUpdate(){
    return this.getBaseUrl() + this.userBaseUrl + "/profileupdate";
  },
  memberAddBank() {
    return this.getBaseUrl() + this.userFundUrl + "/addmemberbank";
  },
  memberAddEwallet(){
    return this.getBaseUrl() + this.userFundUrl + "/addmemberewallet";
  },
  setDefaultBank() {
    return this.getBaseUrl() + this.userFundUrl + "/setdefaultbank";
  },
  getMemberBankList() {
    return this.getBaseUrl() + this.userFundUrl + "/getmemberbanklist";
  },
  getMemberEwallet(){
    return this.getBaseUrl() + this.userFundUrl + "/getbanklistmb";
  },
  activeList(){
    return this.getBaseUrl() + this.userBaseUrl + "/memberbankcount";
  },
  bankLookUp() {
    return this.getBaseUrl() + this.userFundUrl + "/banklookup";
  },
  getBankingMode() {
    return this.getBaseUrl() + this.userFundUrl + "/bankingmode";
  },
  manualDeposit() {
    return this.getBaseUrl() + this.userFundUrl + "/deposit";
  },
  addWithdrawTicket() {
    return this.getBaseUrl() + this.userFundUrl + "/withdrawal";
  },
  getMemberTicketList() {
    return this.getBaseUrl() + this.userReportUrl + "/getticketlist";
  },
  getTurnoverDownline(){
    return this.getBaseUrl() + this.userReportUrl + "/getturnovermember";
  },
  depositOfaPay() {
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositofapay";
  },
  launchGame() {
    return this.getBaseUrl() + this.userBaseUrl + "/launchgame";
  },
  getPromotionStatus() {
    return this.getBaseUrl() + this.userFundUrl + "/getpromotionstatus";
  },
  getMemberStatement() {
    return this.getBaseUrl() + this.userReportUrl + "/getstatement";
  },
  getMemberTransferDetails() {
    return this.getBaseUrl()+ this.userReportUrl + "/gettransferlist";
  },
  getGameResultSlot(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultslot";
  },
  getGameResultLivecasino(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultlc";
  },
  getGameResultRebate(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultrebate"
  },
  getGameResultSb(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultsp"
  },
  getGameResultCockfight(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultcockfight"
  },
  getPlatformWinLose() {
    return this.getBaseUrl() + this.userReportUrl + "/getplatformwinlose";
  },
  getSocialList() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsociallist";
  },
  memberTacValidate(){
    return this.getBaseUrl() + this.userBaseUrl + "/membertacvalidate";
  },
  memberRenewTac(){
    return this.getBaseUrl()+ this.userBaseUrl + "/membertacrenew";
  },
  getPromoStatement(){
    return this.getBaseUrl() + this.userReportUrl + "/getbonuslist";
  },
  getAdjustmentDetails(){
    return this.getBaseUrl() + this.userReportUrl + "/getadjustmentlist";
  },
  getInboxList(){
    return this.getBaseUrl() + this.userFundUrl + "/getinboxlist";
  },
  inboxClaim(){
    return this.getBaseUrl() + this.userFundUrl + "/inboxclaim";
  },
  getTopTenDepositWithdraw(){
    return this.getBaseUrl() + this.userBaseUrl + "/gettoptendw";
  },
  getMemberVip(){
    return this.getBaseUrl() + this.userBaseUrl + "/getmembervip";
  },
  memberBankTac() {
    return this.getBaseUrl() + this.userFundUrl + "/memberbanktac";
  },
  memberTransferMember(){
    return this.getBaseUrl() + this.userFundUrl + "/membertransfermember";
  },
  getGraphData(){
    return this.getBaseUrl() + this.userBaseUrl + "/graph";
  },
  getSurveyQuestion(){
    return this.getBaseUrl() + this.userReviewUrl + "/getreviewlookup";
  },
  getTopTenReview(){
    return this.getBaseUrl() + this.userReviewUrl + "/gettoptensurveylist";
  },
  memberReview(){
    return this.getBaseUrl() + this.userReviewUrl + "/memberreview";
  },
  depositTracker(){
    return this.getBaseUrl() + this.campaignUrl + "/depositcampaign";
  },


  mayaPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositmayapay";
  },
  htPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/deposithtpay";
  },
  aiPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositaipay";
  },
  rmPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositrmpay";
  },
  gopayGcash(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositgopaygcash";
  },
  gopayMaya(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositgopaymaya";
  },
  dgpayGcash(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositdgpaygcash";
  },
  dgpayGcashqr(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositdgpaygcashqr";
  },
  dgpayMaya(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositdgpaymaya";
  },
  cloudPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositcloudpay";
  },
  topPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/deposittoppay";
  },
  anfuPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositanfu";
  },
  shunfapayGcash(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositshunfapaygcash";
  },
  shunfapayMaya(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositshunfapaymaya";
  },
  worldPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositworldpay";
  },
  rgPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositrgpay"
  },
  wcPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositwcpay"
  },
  goldPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositgoldpay"
  },
  xftgCash(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositxftgcash"
  },
  xftUsdt(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositxftusdt"
  },
  masayaPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositmasayapay"
  },
  xyPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositxypay"
  },
  tygPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/deposittygpay"
  },
  ctPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositctpay"
  },
  innpayD0s(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositinnpayd0s"
  },
  innpayD0c(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositinnpayd0c"
  },
  innpayMaya(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositinnpaymaya"
  },
  rkPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositrkpay"
  },
  ezPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositezpay"
  },
  sgPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositsgpay"
  },
  goldPay2(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositgoldpay2"
  },
  rkPaygcash(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositrkpaygcash"
  },
  rkPaygcashQr(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositrkpaygcashqr"
  },
  swPaygcash(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositswpaygcash"
  },
  swPaygcashQr(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositswpaygcashqr"
  },
  getCouponDetails(){
    return this.getBaseUrl() + this.couponUrl + "/getcoupondetails";
  },
  updateEmail(){
    return this.getBaseUrl() + this.userBaseUrl + "/updateemail"
  },
  getRebate() {
    return this.getBaseUrl() + this.userFundUrl + "/memberrebateself";
  },
  getRebateDownline(){
    return this.getBaseUrl() + this.userFundUrl + "/memberrebatedownline";
  },
  getRefereeList(){
    return this.getBaseUrl() + this.userReportUrl + "/getrefereelist";
  },
  claimRebate(){
    return this.getBaseUrl() + this.userFundUrl + "/rebateselfclaim";
  },
  claimRebateDownline(){
    return this.getBaseUrl() + this.userFundUrl + "/rebatedownlineclaim";
  },
  getTurnoverProvider(){
    return this.getBaseUrl() + this.userReportUrl + "/getturnoverprovider";
  },
  getBetList(){
    return this.getBaseUrl() + this.userEventUrl + "/getbetlist"
  },
  getClaimedTickets(){
    return this.getBaseUrl() + this.userEventUrl + "/ticketclaimedlist"
  },
  getRealTimeTrans(){
    return this.getBaseUrl() + this.userReportUrl + "/getdpwithdrawallist"
  },
  getRebateChart(){
    return this.getBaseUrl() + this.userReportUrl + "/rebatechart"
  },
  getProviderGameOfflist(){
    return this.getBaseUrl() + this.userBaseUrl + "/providergameofflist"
  },
  getRtplist(){
    return this.getBaseUrl() + this.userReportUrl + "/getrtplist"
  },
  getTopgame(){
    return this.getBaseUrl() + this.userReportUrl + "/getmembertopgame"
  },
  getXchangeRate(){
    return this.getBaseUrl() + this.userFundUrl + "/exchangeratelist";
  },
  getStreamLink(){
    return this.getBaseUrl() + this.cmsUrl + "/iframelist"
  },
  getPromoDepositCount(){
    return this.getBaseUrl() + this.userFundUrl + "/getpromodepositcount"
  },

  /* fav list */
  getFavlist(){
    return this.getBaseUrl() + this.userFavurl + "/favlist"
  },
  addFav(){
    return this.getBaseUrl() + this.userFavurl + "/addfav"
  },
  removeFav(){
    return this.getBaseUrl() + this.userFavurl + "/removefav"
  },

  /* cms */
  
  getSlideBanner(){
    return this.getBaseUrl() + this.cmsUrl + "/slidebannerlist"
  },
  getAnnBanner(){
    return this.getBaseUrl() + this.cmsUrl + "/announcementbannerlist"
  },
  getPromoBanner(){
    return this.getBaseUrl() + this.cmsUrl + "/promotionbanner"
  },
  getSeo(){
    return this.getBaseUrl() + this.cmsUrl + "/seopagedetails"
  },

  /* appflyer */
  appflyerSubmit(){
    return this.getBaseUrl() + "/appsflyer/appsflyervisit"
  },

  // slots
  launchEpic(){
    return this.epicGame + "/epiclaunchgame"
  },
  launchEpic2(){
    return this.epic2 + "/launchgame"
  },
  getEpicGamelist(){
    return this.epicGame + "/getGameList"
  },
  getEpic2list(){
    return this.epic2 + "/getgamelist"
  },
  launchLive22(){
    return this.live22Game + "/launchgame"
  },
  getLive22GameList(){
    return this.live22Game + "/getgamelist?lang=en"
  },
  getAwcList(){
    return this.awcGame + "/getgamelist"
  },
  launchAwc(){
    return this.awcGame + "/launchgame"
  },
  getFcList(){
    return this.fcGame + "/getgamelist"
  },
  launchFc(){
    return this.fcGame + "/launchgame"
  },
  getJiliList(){
    return this.jiliGame + "/getgamelist"
  },
  launchJili(){
    return this.jiliGame + "/launchgame"
  },
  getCq9List(){
    return this.cq9Game + "/getgamelist"
  },
  launchCq9(){
    return this.cq9Game + "/launchgame"
  },

  getHabaneroList(){
    return this.habaneroGame + "/getgamelist"
  },
  launchHabanero(){
    return this.habaneroGame + "/launchgame"
  },

  getPpsList(){
    return this.ppsGame + "/getgamelist"
  },
  launchPps(){
    return this.ppsGame + "/launchgame"
  },

  getLaunchoneList(){
    return this.launchOne + "/getgamelist"
  },

  launchLaunchOne(){
    return this.launchOne + "/launchgame"
  },

  getYgrList(){
    return this.ygrGame + "/getgamelist"
  },
  launchYgr(){
    return this.ygrGame + "/launchgame"
  },
  launchWow(){
    return this.wowApi + "/launchgame"
  },
  getOpenList(){
    return this.launchOpen + "/getgamelist"
  },
  launchOpenapi(){
    return this.launchOpen + "/launchgame"
  },

  

  // casino
  getEvolist(){
    return this.evoGame + "/getgamelist"
  },
  launchEvo(){
    return this.evoGame + "/launchgame"
  },
  launchPpc(){
    return this.ppCasino + "/launchgame"
  },
  launchTbl(){
    return this.tblGame + "/launchgame"
  },

  //sabong
  launchSabong(){
    return this.sabongGame + "/launchgame"
  },
  launchIronclaw(){
    return this.ironClaw + "/launchgame"
  },

  //sport
  launchWbet(){
    return this.wBet + "/launchgame"
  },

  //game result
  getLive22Result(){
    return this.live22Game + "/getbetdetail"
  },
  getAwcResult(){
    return this.awcGame + "/getbetdetail"
  },
  getEvoResult(){
    return this.evoGame + "/getbetdetail"
  },
  getFcResult(){
    return this.fcGame + "/getbetdetail"
  },
  getJiliResult(){
    return this.jiliGame + "/getbetdetail"
  },
  // getEpicResult(){
  //   return this.epicGame + "/getbetdetail"
  // }
  getEpic2Result(){
    return this.epic2 + "/getbetdetail"
  },
  getCq9Result(){
    return this.cq9Game + "/getbetdetail"
  },
  getHabaneroResult(){
    return this.habaneroGame + "/getbetdetail"
  },
  getPpsResult(){
    return this.ppsGame + "/getbetdetail"
  },
  getPpcResult(){
    return this.ppCasino + "/getbetdetail"
  },
  getLaunchoneResult(){
    return this.launchOne + "/getbetdetail"
  },
  getYgrResult(){
    return this.ygrGame + "/getbetdetail"
  },
  getWowResult(){
    return this.wowApi + "/getbetdetail"
  },
  getOpenapiResult(){
    return this.launchOpen + "/getbetdetail"
  }
};
